/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';

import { useForm } from 'react-hook-form';
import { Collapse, Alert } from '@mui/material';

import { getLinkUnique } from '../../api/userApi';
import { useTranslation } from 'react-i18next';

export const SendLink = () => {

  const {register, handleSubmit, reset, formState: { errors }} = useForm();
  const {t} = useTranslation();

  const [resultsType, setResultsType] = useState(undefined);
  const [resultsText, setResultsText] = useState('');
  const [openAlert, setOpenAlert] = useState(false);

  const onSubmit = (data) => {
    getLinkUnique(data).then((response) => {
      const {results} = response;
      setResultsType(results);
      setResultsText(t('alert.success_send_mail'));
      setOpenAlert(true);
      reset();
    });
  };

  const style = {
    alertContainer: {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      '&.MuiAlert-root': {
        fontSize: '.9em'
      },
      '&.MuiAlert-icon': {
        fontSize:  '1.2em'
      },
    },
    text: {
      fontWeight: 500,
      paddingLeft: '1em'
    }
  };

  return (
    <form  id='user-form' onSubmit={handleSubmit(onSubmit)}>
      <div className="form-input">
        <p>{t('modalLink.title_1')}</p>
        <label className='form-label'>
          <b>{t('modalLink.title_2')}</b>
        </label>
        <input 
          style={{
            width: '100%', 
            height: 40, 
            borderRadius: '.5em', 
            marginTop: '1em', 
            marginBottom: '1em',
            paddingLeft: '.5em'
          }}
          className="form-text" 
          type="email" 
          name="email-return-link" 
          id="email-return-link"  
          {...register('email', {
            required: {
              value: true,
              message: t('modalLink.error_message')
            },
            pattern: {
              value:  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              message: t('modalLink.error_format')
            }
          })}              
        />
        {errors.email && <p className='error-value'>{errors.email.message}</p>}
        <Collapse in={openAlert} collapsedSize={0} mountOnEnter unmountOnExit>
          <Alert 
            sx={style.alertContainer} 
            severity={resultsType}><p style={style.text}>{resultsText}</p></Alert>
        </Collapse>
        <footer className='survey-actions grid xs:grid-col-1 md:grid-col-12'>
          <div className='md:order-1 md:col-start-5 md:col-end-8'>
            <button 
              className='btn btn-block btn-pill btn-primary btn-fill-h'
              type='submit'
            >
              <span>{t('button.send_button')}</span>
              <span className='icon icon icon-arrow-right'></span>
            </button>
          </div>
        </footer>
      </div>
    </form>
  );
};